import { DecimalPipe } from '@angular/common';
import {
    Component,
    Input,
    OnChanges,
    SimpleChanges,
    ChangeDetectionStrategy
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TranslatePipe } from '@ngx-translate/core';

export type CustomerDeviceRow = {
    settingId: number | string;
    serialNumber: string;
    owner: string;
    systemCapacity: string | number;
    smartCharge: string | number;
    Timezone: string;
    panelPower: string | number;
    lowPriceThreshold: string | number;
};

@Component({
    selector: 'app-customer-divice-info',
    standalone: true,
    imports: [
        MatCardModule,
        MatMenuModule,
        MatButtonModule,
        MatTableModule,
        MatProgressBarModule,
        TranslatePipe,
        DecimalPipe
    ],
    templateUrl: './customer-divice-info.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./customer-divice-info.component.scss']
})
export class CustomerDiviceInfoComponent implements OnChanges {
    @Input() devices: CustomerDeviceRow[] = [];
    @Input() isLoading = false;

    displayedColumns: string[] = [
        'settingId',
        'serialNumber',
        'owner',
        'systemCapacity',
        'smartCharge',
        'Timezone',
        'panelPower',
        'lowPriceThreshold'
    ];

    dataSource = new MatTableDataSource<CustomerDeviceRow>([]);

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['devices']) {
            this.dataSource.data = this.devices ?? [];
        }
    }
}
